// @ts-nocheck

import { faEllipsisH, faPlus, faBolt, faChartLine } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from "components/base/Button";
import { DealColumn as Column } from "data/crm/deals";
import { currencyFormat } from "helpers/utils";
import { Dropdown, Badge } from "react-bootstrap";
import DealCard from "components/cards/DealCard";
import { Draggable } from "react-beautiful-dnd";
import { dealsAtom } from "jotai/LeadsJotaiInstance";
import { useAtom } from "jotai";
import { useEffect, useState } from "react";
import axiosInstance from "helpers/api";
import toast from "react-hot-toast";
import ConfirmDeleteModal from "../common-components/ConfirmDeleteModal";

const DealColumn = ({ column, handleOpenAddModal }: any) => {
  const [deals, setDeals] = useAtom(dealsAtom);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedLeadId, setSelectedLeadId] = useState(null);

  const handleShowDeleteModal = (id: any) => {
    setShowDeleteModal(true);
    setSelectedLeadId(id);
  };

  const handleDeleteStage = async (id: any) => {
    try {
      const response = await axiosInstance.delete(`/deals/deal-stages/${id}`);
      toast.success(response.data.message);

      const filterDeals = deals.filter((item: any) => item.id !== id);

      setDeals(filterDeals);
    } catch (error: any) {
      toast.error(error.response.data.message);
    }
  };

  return (
    <div 
      className="deals-column"
      style={{
        background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%)',
        borderRadius: '16px',
        border: '1px solid rgba(0, 212, 255, 0.2)',
        backdropFilter: 'blur(15px)',
        padding: '16px',
        minHeight: '600px',
        width: '320px',
        flexShrink: 0
      }}
    >
      {/* Enhanced Column Header */}
      <div 
        className="d-flex align-items-center justify-content-between position-sticky top-0 z-1 mb-3"
        style={{
          background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.15) 0%, rgba(118, 75, 162, 0.15) 100%)',
          borderRadius: '12px',
          padding: '16px',
          border: '1px solid rgba(0, 212, 255, 0.2)',
          backdropFilter: 'blur(10px)'
        }}
      >
        <div className="flex-grow-1">
          <div className="d-flex align-items-center mb-2">
            <FontAwesomeIcon 
              icon={faBolt} 
              style={{ 
                color: '#00d4ff',
                fontSize: '16px',
                marginRight: '8px',
                filter: 'drop-shadow(0 0 4px rgba(0, 212, 255, 0.5))'
              }}
            />
            <h5 
              className="mb-0"
              style={{ 
                color: '#1f2937', 
                fontWeight: 600,
                fontSize: '16px'
              }}
            >
              {column.deal_stage_name}
            </h5>
          </div>
          
          {/* Deal Count Badge */}
          <div className="d-flex align-items-center gap-2">
            <Badge 
              bg="primary"
              style={{
                background: 'linear-gradient(135deg, #00d4ff 0%, #0ea5e9 100%)',
                border: 'none',
                borderRadius: '8px',
                fontSize: '10px',
                padding: '4px 8px',
                fontWeight: '600'
              }}
            >
              {column?.deals?.length || 0} deals
            </Badge>
            
            {/* Revenue Badge */}
            {column.revenue && (
              <div 
                className="metric-mini text-center"
                style={{
                  background: 'rgba(16, 185, 129, 0.1)',
                  borderRadius: '8px',
                  padding: '4px 8px',
                  border: '1px solid rgba(16, 185, 129, 0.2)',
                  fontSize: '10px'
                }}
              >
                <FontAwesomeIcon icon={faChartLine} className="text-success me-1" />
                <span className="fw-bold text-success">
                  {currencyFormat(column.revenue, { minimumFractionDigits: 0 })}
                </span>
              </div>
            )}
          </div>
        </div>
        
        {/* Enhanced Action Buttons */}
        <div className="d-flex gap-1 ms-2">
          <Button
            variant="outline-primary"
            size="sm"
            className="ai-column-btn"
            onClick={() => handleOpenAddModal(column.id)}
            style={{
              borderRadius: '8px',
              padding: '6px 10px',
              border: '1px solid rgba(0, 212, 255, 0.3)',
              background: 'rgba(0, 212, 255, 0.05)',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = 'rgba(0, 212, 255, 0.1)';
              e.currentTarget.style.borderColor = '#00d4ff';
              e.currentTarget.style.transform = 'scale(1.05)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'rgba(0, 212, 255, 0.05)';
              e.currentTarget.style.borderColor = 'rgba(0, 212, 255, 0.3)';
              e.currentTarget.style.transform = 'scale(1)';
            }}
          >
            <FontAwesomeIcon icon={faPlus} style={{ color: '#00d4ff' }} />
          </Button>
          
          <Dropdown align="end">
            <Dropdown.Toggle
              className="dropdown-caret-none ai-column-btn"
              variant="outline-primary"
              size="sm"
              style={{
                borderRadius: '8px',
                padding: '6px 10px',
                border: '1px solid rgba(0, 212, 255, 0.3)',
                background: 'rgba(0, 212, 255, 0.05)',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = 'rgba(0, 212, 255, 0.1)';
                e.currentTarget.style.borderColor = '#00d4ff';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = 'rgba(0, 212, 255, 0.05)';
                e.currentTarget.style.borderColor = 'rgba(0, 212, 255, 0.3)';
              }}
            >
              <FontAwesomeIcon icon={faEllipsisH} style={{ color: '#00d4ff' }} />
            </Dropdown.Toggle>

            <Dropdown.Menu 
              className="p-0"
              style={{
                background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(255, 255, 255, 0.9) 100%)',
                backdropFilter: 'blur(10px)',
                border: '1px solid rgba(0, 212, 255, 0.2)',
                borderRadius: '12px',
                overflow: 'hidden'
              }}
            >
              <Dropdown.Item 
                onClick={() => handleShowDeleteModal(column.id)}
                style={{
                  padding: '12px 16px',
                  fontSize: '14px',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = 'rgba(0, 212, 255, 0.1)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'transparent';
                }}
              >
                Delete Stage
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
      
      {/* Enhanced Deal Cards Container */}
      <div 
        className="scrollbar flex-1 d-flex flex-column gap-3"
        style={{
          maxHeight: '500px',
          overflow: 'auto',
          paddingRight: '4px'
        }}
      >
        {column?.deals
          ?.sort((a, b) => a.deal_index - b.deal_index)
          ?.map((item, index) => (
            <Draggable
              key={item.id}
              draggableId={item.id.toString()}
              index={index}
            >
              {(provided) => (
                <div
                  ref={provided.innerRef}
                  {...provided.draggableProps}
                  {...provided.dragHandleProps}
                  style={{
                    ...provided.draggableProps.style,
                    transition: 'all 0.3s ease'
                  }}
                >
                  <DealCard deal={item} key={item.id} columnId={column.id} />
                </div>
              )}
            </Draggable>
          ))}
          
        {/* Empty State */}
        {(!column?.deals || column.deals.length === 0) && (
          <div 
            className="text-center py-4"
            style={{
              background: 'rgba(255, 255, 255, 0.02)',
              borderRadius: '12px',
              border: '2px dashed rgba(0, 212, 255, 0.2)',
              color: '#6b7280'
            }}
          >
            <FontAwesomeIcon 
              icon={faPlus} 
              style={{ 
                fontSize: '24px',
                marginBottom: '8px',
                color: 'rgba(0, 212, 255, 0.3)'
              }}
            />
            <p className="mb-0" style={{ fontSize: '14px' }}>
              No deals in this stage
            </p>
            <small style={{ fontSize: '12px', color: '#9ca3af' }}>
              Add your first deal to get started
            </small>
          </div>
        )}
      </div>
      
      <ConfirmDeleteModal
        modalShow={showDeleteModal}
        setModalShow={setShowDeleteModal}
        type="Stage"
        handleDelete={() => handleDeleteStage(selectedLeadId)}
      />
    </div>
  );
};

export default DealColumn;
